import React from 'react';
import { useNavigate } from 'react-router-dom';
import "../services/services.css"; // Your custom styling
import InnerLayout from "../../layouts/InnerLayout.js";
import InnerBanner from "../../components/innerBanner/innerBanner.js";
import { Card, CardContent, Button, Typography, Box, Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import useServices from '../../appSettings/customhooks/servicehook.js'; // Use custom hook directly
import { IMAGE_SERVICES_URL, images } from '../../appSettings/imageConstants.js'; // Image constants
import InnerBannerImage from '../../images/inner-banner.png';

function Services() {
  const navigate = useNavigate();
  const { services, loading, error } = useServices(); // Fetch services directly via the hook

  if (loading) return <div>Loading the services...</div>;
  if (error) return <div>{error}</div>;

  return (
    <InnerLayout>
      <InnerBanner bannerImage={InnerBannerImage} title="Services" tagline="Our Services for Students" />
      <Box component="section">
        <Container maxWidth="xl">
          <Grid container spacing={5}>
            {services.map((item, index) => (
              <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <Card 
                  className="serviceCard"
                  align="center"
                  sx={{ height: '100%', cursor: 'pointer' }}
                  onClick={() => navigate(`/services/${item.slug}`)}
                >
                  <CardContent>
                    <Box
                      component="img"
                      src={item.image ? `${IMAGE_SERVICES_URL}${item.image}` : images.NoImage} 
                      alt={item.title}
                      sx={{ width: "100px", mb: 2 }}
                    />
                    <Typography gutterBottom variant="h5" component="div">
                      {item.title}
                    </Typography>
                    {item?.short_description && (
                      <Box
                        component="div"
                        variant="body2"
                        color="text.secondary"
                        dangerouslySetInnerHTML={{ __html: item.short_description }}
                      />
                    )}
                    <Button
                      size="small"
                      variant="contained"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/services/${item.slug}`);
                      }}
                    >
                      Read More
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </InnerLayout>
  );
}

export default Services;
